import { plainToInstance } from 'class-transformer'
import { Guid } from 'guid-typescript'

import BaseButtonBuilder, { BaseButtonViewData } from '../../index'
import { ButtonTypes } from '../../types'
import { BaseFlowButtonWithOutput } from '../BaseFlowButtonWithOutput'
import setupView from './RunFlowNodeButtonSetupView.vue'
import buttonView from './RunFlowNodeButtonView.vue'

export default class RunFlowNodeButtonBuilder extends BaseButtonBuilder {
  type = ButtonTypes.RunFlowNode

  titleKey = ButtonTypes.RunFlowNode

  setupView = setupView
  buttonView = buttonView

  icon = '🚀'

  data = new RunFlowNodeButtonData(this.$i18n.t('initial_text_message_editor_buttons').toString())

  getData(button?: RunFlowNodeButton): RunFlowNodeButtonData {
    return new RunFlowNodeButtonData(button ? button : this.$i18n.t('initial_text_message_editor_buttons').toString())
  }

  create(): RunFlowNodeButton {
    return plainToInstance(RunFlowNodeButton, {
      ...this.data,
      type: ButtonTypes.RunFlowNode,
      guid: Guid.create().toString()
    })
  }
}

export class RunFlowNodeButtonData implements BaseButtonViewData {
  text: string
  output: number | null = null

  constructor(arg: RunFlowNodeButton | string) {
    if (arg instanceof RunFlowNodeButton) {
      const { text, output } = arg

      this.text = text
      this.output = output
    } else {
      this.text = arg
    }
  }
}

export class RunFlowNodeButton extends BaseFlowButtonWithOutput {
  declare type: ButtonTypes.RunFlowNode
}
